import * as React from 'react';
import { C as Context } from './injectIntl-BtqeBzQq.js';
import { i as invariantIntlContext } from '../utils-BIG_B-Jx.js';

function useIntl() {
    var intl = React.useContext(Context);
    invariantIntlContext(intl);
    return intl;
}

export { useIntl as u };
//# sourceMappingURL=useIntl-CDWrzlE7.js.map
